import styled from "@emotion/styled";

const FaqAnswerDiv = styled.div([
  props => props.theme.typography.faqAnswerText,
  props => props.theme.colors.background.faqAnswer,
  `
      padding: 0 10px;
      overflow: hidden;
      transition: max-height 0.2s ease-out;
    `,
  `
    p {
      margin-bottom: 8px;
    }
    `,
  `
    span.bold {
      font-family: $vfBold;
      font-size: 14px;
      text-decoration: none;
    }    
    `,
  `
    ul {
      padding-left: 20px;
      margin: 0;
    }    
    `,
  `
    li {
      margin-left: 0;
      margin-bottom: 8px;
    }  
    `,
  `
    a {
      color: $grey;
    }    
    `
]);

const FaqAnswerSubDiv = styled(FaqAnswerDiv)([
  props => props.theme.colors.background.primary,
  `
    padding: 20px;
    margin: 20px;
    border: 1px solid #e3e3e3;
    border-radius: 5px;
  `]);

const FaqAccordionItem: React.FC<{ title: string, isExpanded: boolean, onClick: () => void }> = ({ title, isExpanded, onClick, children }) => {
  return (
    <div className="accordion__item">
      <div className={`accordion__heading ${isExpanded ? "accordion-active" : ""}`} onClick={onClick}>
        <span className="accordion__title">
          {title}
        </span>
        <span className={`accordion__icon ${isExpanded ? "accordion__icon--turn" : ""}`} />
      </div>
      <FaqAnswerDiv style={{ maxHeight: isExpanded ? 10000 : 0 }}>
        <FaqAnswerSubDiv>
          {children}
        </FaqAnswerSubDiv>
      </FaqAnswerDiv>
    </div>
  )
}

export default FaqAccordionItem;